module.exports = __webpack_public_path__ + "static/media/coming-soon-text.b70d20f6.png";